export default __webpack_public_path__ + "static/media/wheel_of_fortune_out_of_service.d821b9cf.png";